import { Link } from "react-router-dom";
import { ArrowRight, Home, BookOpen, Phone } from "lucide-react";
import { Seo } from "@/components/Seo";

const links = [
  { to: "/", icon: Home, label: "Úvodní stránka", desc: "Zpět na hlavní stránku" },
  { to: "/kurzy", icon: BookOpen, label: "Naše kurzy", desc: "Aktuální nabídka kurzů" },
  { to: "/kontakt", icon: Phone, label: "Kontakt", desc: "Ozvěte se nám" },
];

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="bg-gavito-light min-h-[70vh]">
      <Seo title="Stránka nenalezena" description="Požadovaná stránka nebyla nalezena." noindex />
      <section className="pt-40 md:pt-52 pb-28">
        <div className="max-w-4xl mx-auto px-6 md:px-10">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-gavito-green mb-4">Chyba 404</p>
          <h1 className="font-heading font-black text-5xl md:text-7xl tracking-tighter text-gavito-navy leading-[0.95]">
            Tato stránka<br />už tu není.
          </h1>
          <p className="mt-8 text-lg md:text-xl font-medium text-gavito-navy/70 max-w-xl leading-relaxed">
            Náš web prošel proměnou. Adresa, kterou hledáte, se přesunula nebo již neexistuje.
            Níže vás rádi navedeme na to důležité.
          </p>

          <div className="mt-12 grid sm:grid-cols-3 gap-5">
            {links.map(({ to, icon: Icon, label, desc }) => (
              <Link
                key={to}
                to={to}
                data-testid={`notfound-link-${to === "/" ? "home" : to.slice(1)}`}
                className="group bg-white border border-gavito-navy/10 rounded-3xl p-7 hover:border-gavito-green hover:-translate-y-1 transition-all duration-300"
              >
                <span className="w-11 h-11 rounded-full bg-gavito-navy/5 flex items-center justify-center text-gavito-navy group-hover:bg-gavito-green group-hover:text-white transition-colors">
                  <Icon className="w-5 h-5" />
                </span>
                <p className="font-heading font-bold text-xl text-gavito-navy mt-5 flex items-center gap-1.5">
                  {label} <ArrowRight className="w-4 h-4 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                </p>
                <p className="text-sm text-gavito-navy/55 mt-1">{desc}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
